import React, { useState, useEffect } from "react";
import {
  PlusOutlined,
  DeleteOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
//outsource
import { Row, Col, Modal, Button } from "antd";
//component
import DialogUserSearch from "./component/dialog_user_search";
import DialogDate from "./component/dialog_date";
import DialogTime from "./component/dialog_time";
import moment from "moment";
//redux
import { useDispatch, useSelector } from "react-redux";
import {
  snapDateTracking,
  addTime,
  deleteTimeTracking,
} from "../../../store/time_tracking/time_tracking.action";

import { setOpen } from "../../../store/report/report.action";
import { openSelector } from "../../../store/report/report.selector";
import { company } from "../../../store/report/report.selector";

const { confirm } = Modal;

const DialogTimeAdd = () => {
  // -------------------------- VAR --------------------------

  // -------------------------- STATE --------------------------
  const [userId, setUserId] = useState("");
  const [date, setDate] = useState(null);
  const [disabledDate, setDisabledDate] = useState(false);
  const [time, setTime] = useState(null);
  const [disabledTime, setDisabledTime] = useState(false);
  const [arr, setArr] = useState(new Array(8).fill(null));
  const [disabled, setDisabled] = useState(true);
  const [timeTracking, setTimeTracking] = useState(null);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const open = useSelector(openSelector);
  const branch = useSelector(company);
  //   const timeTracking = useSelector(dateTrackingSelector);
  let dataTracking = timeTracking
    ? timeTracking?.map((item) => item?.checkedAt)
    : null;
  let lastTime = dataTracking ? dataTracking[0] : null;
  // console.log({ lastTime });
  // -------------------------- FUNCTION --------------------------
  const handleCancel = () => {
    dispatch(
      setOpen({ data: false }, () => {
        resetFields();
      })
    );
  };

  const resetFields = () => {
    setUserId("");
    setDate(null);
    setTime(null);
    setDisabledDate(false);
    setDisabledTime(false);
    setDisabled(true);
    setTimeTracking(null);
  };

  const handleAdd = () => {
    if (branch && date && time && userId !== "") {
      dispatch(addTime({ branch, date, time, user: userId }));
    }
  };

  const handleDelete = (id) => {
    if (id && id !== "") {
      dispatch(deleteTimeTracking({ id }));
    }
  };

  // -------------------------- EFFECT --------------------------
  //set reset variable
  useEffect(() => {
    if (userId === "") {
      setDate(null);
      setDisabledDate(true);
    }

    if (userId !== "") {
      setDisabledDate(false);
    }
  }, [userId]);

  useEffect(() => {
    if (!date) {
      setTime(null);
      setDisabledTime(true);
    }

    if (date) {
      setDisabledTime(false);
    }
  }, [date]);

  //import the Date tracking
  useEffect(() => {
    if (date && branch && userId !== "") {
      dispatch(
        snapDateTracking({ date, branch, user: userId }, (data) => {
          setTimeTracking(data);
        })
      );
    }

    if (!date) {
      setTimeTracking(null);
    }
  }, [dispatch, date, userId, branch]);

  //disabled button add
  useEffect(() => {
    setDisabled(true);

    if (date && branch && userId !== "" && time) {
      setDisabled(false);
    }
  }, [date, userId, time, branch]);

  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row>
        <Col xl={24} lg={24} md={24} xs={24}>
          {renderControl()}
        </Col>
        <Col style={{ marginTop: 20 }} xl={24} lg={24} md={24} xs={24}>
          {renderBlockTime()}
          {renderTrackingTime()}
        </Col>
      </Row>
    );
  };

  const renderControl = () => {
    return (
      <Row gutter={[10, 10]}>
        <Col flex="auto">
          <DialogUserSearch setUserId={setUserId} />
        </Col>
        <Col flex="150px">
          <DialogDate date={date} setDate={setDate} disabled={disabledDate} />
        </Col>
        <Col flex="150px">
          <DialogTime
            date={date}
            time={time}
            setTime={setTime}
            lastTime={lastTime}
            disabled={disabledTime}
          />
        </Col>
        <Col align="right" flex="100px">
          <Button
            style={{
              backgroundColor: disabled ? "gray" : "green",
              color: "white",
              border: 0,
            }}
            type="primary"
            icon={<PlusOutlined />}
            disabled={disabled}
            onClick={handleAdd}
          >
            Add
          </Button>
        </Col>
      </Row>
    );
  };

  const renderBlockTime = () => {
    if (!timeTracking) {
      return (
        <Row gutter={[10, 10]}>
          {arr?.map((item, i) => {
            const number = Math.round(i / 2) + (i % 2 === 0 ? 1 : 0);
            // const id = i % 2 === 0 ? `in${number}` : `out${number}`;
            const label = i % 2 === 0 ? `In ${number}` : `Out ${number}`;
            const block = (
              <Col align="center" span={6}>
                <Button style={{ width: "95%" }} type="default" disabled>
                  {label}
                </Button>
              </Col>
            );

            return block;
          })}
        </Row>
      );
    }
    return null;
  };

  const renderTrackingTime = () => {
    if (timeTracking) {
      const converted = convertFullBlock(timeTracking);
      return (
        <Row gutter={[10, 10]}>
          {converted?.map((item, i) => {
            const number = Math.round(i / 2) + (i % 2 === 0 ? 1 : 0);
            // const id = i % 2 === 0 ? `in${number}` : `out${number}`;
            const label = i % 2 === 0 ? `In ${number}` : `Out ${number}`;
            const block = (
              <Col align="center" span={6}>
                <Button style={{ width: "95%" }} type="default" disabled>
                  {label}
                </Button>
              </Col>
            );

            const labelTime =
              item?.checkedAt &&
              moment(item?.checkedAt?.toDate()).format("hh:mm A");

            if (item === null) {
              return block;
            } else {
              return (
                <Col align="center" span={6}>
                  <Button
                    icon={<DeleteOutlined style={{ color: "red" }} />}
                    style={{ width: "95%" }}
                    type="default"
                    onClick={() => showDeleteConfirm({ item })}
                  >
                    {labelTime}
                  </Button>
                </Col>
              );
            }
          })}
        </Row>
      );
    }
  };

  const showDeleteConfirm = ({ item }) => {
    const checkedAt =
      item?.checkedAt && moment(item?.checkedAt?.toDate()).format("hh:mm A");
    const id = item?.id;
    confirm({
      title: `Are you sure delete time: ${checkedAt}?`,
      icon: <ExclamationCircleFilled />,
      //   content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleDelete(id);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  // -------------------------- MAIN --------------------------
  return (
    <Modal
      type="basic"
      title="Add new Record"
      open={open}
      onCancel={handleCancel}
      footer={null}
      width={800}
    >
      {renderBody()}
    </Modal>
  );
};

export default DialogTimeAdd;

const convertFullBlock = (data) => {
  //sort data
  const sorted = data?.sort((a, b) => a.checkedAt - b.checkedAt);
  let final = [];
  //check full length
  const len = data?.length;
  if (len < 8) {
    const fill = 8 - len;
    const add = new Array(fill).fill(null);
    final = [...final, ...sorted, ...add];
  } else {
    final = [...final, ...sorted];
  }

  return final;
};
